import { useEffect } from 'react';

/**
 * Hook to manage body scroll based on a condition.
 *
 * @param {boolean} shouldDisableScroll - Whether to disable body scroll.
 *
 * @example
 * useBodyScroll(true); // Disables body scroll
 */
export function useBodyScroll(shouldDisableScroll: boolean) {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const originalHtmlOverflow = html.style.overflow;
    const originalBodyOverflow = body.style.overflow;

    if (shouldDisableScroll) {
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    }

    return () => {
      html.style.overflow = originalHtmlOverflow;
      body.style.overflow = originalBodyOverflow;
    };
  }, [shouldDisableScroll]);
}
